/**
 * Restaurant Configuration Module
 * Handles restaurant switching and configuration updates
 */

import { NotificationManager } from '../utils/notifications.js';

export class RestaurantConfigManager {
  constructor(app) {
    this.app = app;
  }

  async switchRestaurant(restaurantId) {
    try {
      await this.app.configManager.switchRestaurant(restaurantId);
    } catch (error) {
      console.error('Failed to switch restaurant:', error);
    }
  }

  async reloadConfiguration() {
    try {
      await this.app.configManager.reloadConfig();
    } catch (error) {
      console.error('Failed to reload configuration:', error);
    }
  }

  async testAPIConnection() {
    try {
      NotificationManager.info('Testing API connection...');
      const config = await this.app.configManager.api.getRestaurantConfig(
        this.app.configManager.getCurrentRestaurantId()
      );
      NotificationManager.success('API connection successful!');
    } catch (error) {
      console.error('API test failed:', error);
      NotificationManager.error('API connection failed');
    }
  }

  async onConfigurationChange(config, restaurantId) {
    this.app.initializer.initializeComponents();

    await this.app.initializer.render();
    this.app.eventHandlers.bindComponentEvents();

    this.app.configManager.applyBranding();

    this.app.restaurantSelector.updateSelection(restaurantId);
  }
}
